export interface FeedItem {
  id: string;
  time: string;
  tag: string;
  tagTone: 'primary' | 'accent' | 'secondary';
  title: string;
  desc: string;
  reads: string;
  hot: string;
}

export interface TargetItem {
  id: string;
  rank: number;
  name: string;
  tag: string;
  heat: string;
  trend: 'up' | 'down' | 'flat';
  title: string;
  desc: string;
  source: string;
  update: string;
  tags: string[];
}

export interface TopicStep {
  time: string;
  label: string;
  desc: string;
}

export interface TopicItem {
  id: string;
  subject: string;
  category: string;
  heat: string;
  title: string;
  desc: string;
  sources: string[];
  lastUpdate: string;
  steps: TopicStep[];
}

export interface ArchiveItem {
  id: string;
  time: string;
  title: string;
  heat: string;
}

export interface ArchiveGroup {
  key: string;
  label: string;
  items: ArchiveItem[];
}

export interface CommentItem {
  id: string;
  user: string;
  vote: string;
  text: string;
  agree: string;
  time: string;
}

export const liveFeeds: FeedItem[] = [
  { id: 'l1', time: '刚刚', tag: '新鲜', tagTone: 'primary', title: '一条疑似凌晨流出的私聊截图开始在各粉丝群快速扩散', desc: '截图涉及某热播剧男配的私下言论，配文口径正在分裂。', reads: '12.8w', hot: '9.2' },
  { id: 'l2', time: '3 分钟前', tag: '快讯', tagTone: 'accent', title: '某直播头部账号被拍到深夜现身品牌总部', desc: '目击视频由同城博主发布，评论区已涌入大量猜测。', reads: '8.1w', hot: '8.6' },
  { id: 'l3', time: '6 分钟前', tag: '争议', tagTone: 'secondary', title: '选秀出身歌手旧综艺片段被考古，措辞引发两面评价', desc: '片段登顶热议榜第 4，各方观点仍在拉锯。', reads: '6.3w', hot: '7.9' },
  { id: 'l4', time: '11 分钟前', tag: '新料', tagTone: 'primary', title: '商务圈流出合作意向函，疑似影射某流量小生接戏档期', desc: '意向函关键字段被涂黑，真实性尚未获平台回应。', reads: '15.4w', hot: '9.5' },
];

export const hotTargets: TargetItem[] = [
  { id: 't1', rank: 1, name: 'A某 · 选秀顶流', tag: '塌房预警', heat: '98.6', trend: 'up', title: '旧访谈被翻出，昔日发言与新料时间线对不上', desc: '网友逐帧核对两年间的行程与直播记录，制作了完整对照表。', source: '17 个账号同步搬运', update: '2 分钟前更新', tags: ['时间线', '打脸'] },
  { id: 't2', rank: 2, name: 'B某 · 直播一哥', tag: '被拍到', heat: '94.2', trend: 'up', title: '深夜现身争议园区，随行安保配置异常', desc: '三张路透图构图完整，被指拍摄角度刻意。', source: '同城目击者实拍', update: '8 分钟前更新', tags: ['实拍', '行踪'] },
  { id: 't3', rank: 3, name: 'C某 · 新生代演员', tag: '新料', heat: '89.7', trend: 'flat', title: '剧组聚餐账单流出，单据金额与公开说法不符', desc: '单据抬头、日期齐全，粉丝方与工作室口径暂未对齐。', source: '投稿人提供', update: '14 分钟前更新', tags: ['账目', '多方口径'] },
  { id: 't4', rank: 4, name: 'D某 · 综艺常驻', tag: '考古', heat: '82.4', trend: 'down', title: '两年前直播片段被重新解读，弹幕风向再次翻转', desc: '早期评论被截图，与今日热议形成鲜明反差。', source: '旧档考古', update: '21 分钟前更新', tags: ['考古', '反转'] },
  { id: 't5', rank: 5, name: 'E某 · 幕后主理人', tag: '商务', heat: '76.1', trend: 'flat', title: '一份署名不明的分成表在业内群流传', desc: '表格字段被遮挡大半，可辨认处指向多个项目代号。', source: '业内群流出', update: '26 分钟前更新', tags: ['商务', '分成'] },
];

export const indexTargets: TargetItem[] = [
  { id: 'i1', rank: 6, name: 'F某 · 说唱厂牌成员', tag: '实锤迹象', heat: '71.3', trend: 'up', title: '演出后台监控截图与声明时间对不上', desc: '三张监控时间戳可相互印证，厂牌暂无回应。', source: '现场观众提供', update: '30 分钟前更新', tags: ['监控', '声明'] },
  { id: 'i2', rank: 7, name: 'G某 · 剧集男二', tag: '商务', heat: '66.8', trend: 'flat', title: '代言到期后的品牌联动被扒，疑似提前解约', desc: '多个品牌站内物料同日下线，节奏异常统一。', source: '品牌站内巡查', update: '38 分钟前更新', tags: ['代言', '解约'] },
  { id: 'i3', rank: 8, name: 'H某 · 网红店主', tag: '账目', heat: '61.5', trend: 'down', title: '直播助农产品成本被逐项拆解', desc: '热心网友列出采购链路，成本与售价差值引发讨论。', source: '拆解帖', update: '45 分钟前更新', tags: ['助农', '成本'] },
  { id: 'i4', rank: 9, name: 'I某 · 爱豆成员', tag: '行程', heat: '57.2', trend: 'up', title: '团体行程表被核对出空档期', desc: '长达 11 天的空档与公开请假说法存在出入。', source: '行程表对照', update: '52 分钟前更新', tags: ['行程', '空档'] },
  { id: 'i5', rank: 10, name: 'J某 · 选秀导师', tag: '新料', heat: '52.9', trend: 'flat', title: '一张签名合影被指出后期处理痕迹', desc: '光影细节被放大后结论分歧较大，仍未定论。', source: '图源投稿', update: '1 小时前更新', tags: ['P图', '存疑'] },
  { id: 'i6', rank: 11, name: 'K某 · 独立乐队主唱', tag: '考古', heat: '49.4', trend: 'flat', title: '三年前的小型演出repo被重新转发', desc: 'repo 提到的细节与近况产生微妙呼应。', source: 'repo 考古', update: '1 小时前更新', tags: ['演出', '呼应'] },
];

export const featuredTopic: TopicItem = {
  id: 'tp1',
  subject: 'A某 · 选秀顶流',
  category: '今日头号',
  heat: '98.6',
  title: '「旧访谈考古」事件的完整脉络',
  desc: '从一条凌晨转发的旧访谈，到 27 小时后形成的全网对照时间线——我们按出现顺序还原了今日曝光新料的每一步扩散与质疑。',
  sources: ['访谈旧档', '直播录屏', '行程表', '粉丝群截图'],
  lastUpdate: '5 分钟前',
  steps: [
    { time: '00:12', label: '旧访谈被翻出', desc: '一段 2023 年的访谈被切片转发，其中发言开始被逐句比对。' },
    { time: '01:40', label: '时间线对照帖成型', desc: '热心网友制出两年行程对照表，指出 3 处时间点存在出入。' },
    { time: '06:15', label: '二次扩散至头部账号', desc: '多个娱乐资讯账号接力搬运，单帖阅读量在 2 小时内破百万。' },
    { time: '11:30', label: '粉丝方向反转', desc: '两版口径在评论区对峙，争议热度反推话题冲上热议榜第 1。' },
    { time: '19:06', label: '进入全网追踪阶段', desc: '各站开启「待回应」计时，实时汇总仍在持续更新中。' },
  ],
};

export const archiveGroups: ArchiveGroup[] = [
  {
    key: 'fresh',
    label: '刚刚流出',
    items: [
      { id: 'a1', time: '2 分钟前', title: '商务意向函流出，指向某流量演员档期冲突', heat: '98.6' },
      { id: 'a2', time: '5 分钟前', title: '深夜路透照流出，直播一哥现身争议园区', heat: '94.2' },
      { id: 'a3', time: '9 分钟前', title: '私聊截图流出，牵涉热播剧男配私下言论', heat: '89.7' },
      { id: 'a4', time: '13 分钟前', title: '剧组聚餐账单流出，单据金额对不上公开说法', heat: '84.1' },
      { id: 'a5', time: '17 分钟前', title: '签售会后台视频流出，状态与官方说法相左', heat: '78.5' },
    ],
  },
  {
    key: 'hot',
    label: '今日曝光',
    items: [
      { id: 'b1', time: '11 分钟前', title: '选秀顶流旧访谈考古，3 处时间点存疑', heat: '98.6' },
      { id: 'b2', time: '20 分钟前', title: '直播一哥夜访园区，安保配置被指异常', heat: '94.2' },
      { id: 'b3', time: '28 分钟前', title: '演员聚餐账目与声明不符，暂未回应', heat: '88.9' },
      { id: 'b4', time: '35 分钟前', title: '品牌联动同日下线，疑似提前解约', heat: '82.4' },
    ],
  },
  {
    key: 'expose',
    label: '今日新料',
    items: [
      { id: 'c1', time: '16 分钟前', title: '又一位新人被翻旧账，出道前发言被重新审视', heat: '87.3' },
      { id: 'c2', time: '24 分钟前', title: '物料被发现后期处理痕迹，结论仍存疑', heat: '79.6' },
      { id: 'c3', time: '31 分钟前', title: '行程表空档被核实，与请假说法有出入', heat: '73.4' },
      { id: 'c4', time: '42 分钟前', title: '旧综艺片段重新解读，弹幕风向再反转', heat: '67.8' },
    ],
  },
  {
    key: 'comment',
    label: '网友热议',
    items: [
      { id: 'd1', time: '3 分钟前', title: '两版口径在评论区对峙，谁的说法更站得住', heat: '92.1' },
      { id: 'd2', time: '18 分钟前', title: '对照表逐条拆解：这 3 个时间点最值得看', heat: '85.4' },
      { id: 'd3', time: '29 分钟前', title: '「吃瓜也要讲证据」争论冲上热议榜首', heat: '80.7' },
    ],
  },
];

export const comments: CommentItem[] = [
  { id: 'cm1', user: '一颗泡腾片', vote: '高赞', text: '先把两张图的EXIF和时间线拉出来再说，别急着站队，这个局还没定论。', agree: '2.3万', time: '4 分钟前' },
  { id: 'cm2', user: '凌晨不睡', vote: '高赞', text: '对照表我看了三遍，第2个时间点确实是实锤级别的对不上，不是带节奏。', agree: '1.8万', time: '9 分钟前' },
  { id: 'cm3', user: '饭要趁热', vote: '新', text: '两家口径差这么多，等官方一版回应再下结论，不然来回打脸很累。', agree: '9867', time: '13 分钟前' },
  { id: 'cm4', user: '图库管理员', vote: '新', text: '这张路透的构图太整了，现场机位更像摆拍，建议等更高清的版本。', agree: '7214', time: '21 分钟前' },
];

export const marqueeItems: string[] = [
  '商务意向函流出 · 影射档期冲突',
  '直播一哥深夜被拍到现身争议园区',
  '选秀顶流旧访谈考古登顶热议榜',
  '剧组聚餐账单与公开说法对不上',
  '某爱豆行程表被核实出 11 天空档',
  '品牌物料同日下线疑似提前解约',
  '签售会后台视频状态引热议',
];

export const categoryNav: string[] = ['今日热点', '刚刚流出', '今日曝光', '新鲜黑料', '商务风向', '考古时间线'];